var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, IconButton, TextField, Typography, styled } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { AudioFrameIcon, BluePauseIconNew, DeleteButtonNewIcon } from '../../assets/images';
import { MuiButton } from '../atoms/buttonComponent';
import { MuiStack } from '../atoms/stackComponent';
import { AudioPlayer } from '../molecules/audioComponent';
import ImageCaptureAndFileupload from './captureImageAndFileUpload/imageCaptureAndFileupload';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getListAPI, setState } from '../../redux/crudSlice';
import { setDocDataUpdated, setIsTaskDetailsDataUpdated, showLoader, showNotification } from '../../redux/commonSlice';
import { MuiImagePopUp } from '../atoms/imageDialogBox';
import { convertBlobToWav, GoogleAnlyticsErrorLog } from '../../utils/utils';
import { t } from 'i18next';
import { ESystemName, FreeTextMaxLength, LOCAL_STORAGE_KEYS } from '../../constants';
import { useParams } from 'react-router-dom';
import { deleteAllJobCardAttachmentsUrl } from '../../api/url';
import { GridCloseIcon } from '@mui/x-data-grid-premium';
import { AudioButtonIcon, GalleryIcon } from '../../assets/customIcons';
import { systemColor } from '../../theme/systemColor';
import { getLocalStorageItem } from '../../utils/storageHelper';
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "24px",
        width: "24px"
    };
});
export var FinalInspectorObservation = function (props) {
    var _savedAudio$audioBlob;
    var onDataReceived = props.onDataReceived, MaxLength = props.MaxLength, isDisabled = props.isDisabled, _a = props.isRecordAudio, isRecordAudio = _a === void 0 ? true : _a, ComplaintInputPlaceHolder = props.ComplaintInputPlaceHolder, _b = props.clearDataOnSave, clearDataOnSave = _b === void 0 ? true : _b, comments = props.comments, savedPhotos = props.savedPhotos, savedAudio = props.savedAudio, createAndEditFlow = props.createAndEditFlow, isFromTaskDetails = props.isFromTaskDetails, isDataUpdated = props.isDataUpdated, _c = props.isFromFinalInspection, isFromFinalInspection = _c === void 0 ? false : _c;
    var finalInspectorObservationDetails = useAppSelector(function (state) { return state.crud; }).finalInspectorObservationDetails;
    var dispatch = useAppDispatch();
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(0), audioDuration = _e[0], setAudioDuration = _e[1];
    var _f = useState([]), complaintsPhotographList = _f[0], setcomplaintsPhotographList = _f[1];
    var _g = useState(false), starRecording = _g[0], setStarRecording = _g[1];
    var _h = useState((_savedAudio$audioBlob = savedAudio === null || savedAudio === void 0 ? void 0 : savedAudio.audioBlobUrl) !== null && _savedAudio$audioBlob !== void 0 ? _savedAudio$audioBlob : ""), audioUrl = _h[0], setAudioUrl = _h[1];
    var _j = useState(null), stream = _j[0], setStream = _j[1];
    var mediaRecorder = useRef(null);
    var audio = new Audio(audioUrl !== null && audioUrl !== void 0 ? audioUrl : '');
    var _k = useState(false), isPlaying = _k[0], setIsPlaying = _k[1];
    var _l = useState([]), audioChunks = _l[0], setAudioChunks = _l[1];
    var _m = useState('user'), facingMode = _m[0], setFacingMode = _m[1];
    var _o = useState(false), singleImgSelected = _o[0], setSingleImageSelected = _o[1];
    var _p = useState(false), clearPopUpImages = _p[0], setClearPopUpImages = _p[1];
    var _q = useState(false), isDrawerOpen = _q[0], setISDrawerOpen = _q[1];
    var _r = useState(""), imageURL = _r[0], setImageURL = _r[1];
    var fileInputRef = useRef(null);
    var _s = useState(true), disableSaveButton = _s[0], setDisableSaveButton = _s[1];
    var jobCardId = useParams().jobCardId;
    var _t = useState({
        discription: comments !== null && comments !== void 0 ? comments : '',
        images: savedPhotos !== null && savedPhotos !== void 0 ? savedPhotos : [],
        audio: {
            audioBlobUrl: '',
            audioFile: '',
            AttachmentId: ''
        },
        audioDuration: 0
    }), complaint = _t[0], setComplaint = _t[1];
    useEffect(function () {
        var _savedAudio$audioBlob2;
        var sortedPhotos = (savedPhotos !== null && savedPhotos !== void 0 ? savedPhotos : []).sort(function (a, b) {
            return new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime();
        });
        setComplaint(_objectSpread(_objectSpread({}, complaint), {}, {
            discription: comments ? comments : "",
            images: sortedPhotos
        }));
        setcomplaintsPhotographList(sortedPhotos);
        setAudioUrl((_savedAudio$audioBlob2 = savedAudio === null || savedAudio === void 0 ? void 0 : savedAudio.audioBlobUrl) !== null && _savedAudio$audioBlob2 !== void 0 ? _savedAudio$audioBlob2 : "");
    }, [comments, savedPhotos, savedAudio]);
    var onOpenClick = function () {
        setOpen(true);
    };
    var handleCancleClick = function (value) {
        setOpen(value);
    };
    var onRecordClick = function () {
        setStarRecording(true);
    };
    useEffect(function () {
        var interval;
        if (isPlaying) {
            var startTime_1 = Date.now();
            interval = setInterval(function () {
                setAudioDuration(Math.floor((Date.now() - startTime_1) / 1000));
            }, 1000);
        }
        return function () {
            clearInterval(interval);
        };
    }, [isPlaying]);
    var startRecording = function () {
        // if (audioUrl) {
        //     Play()
        // } 
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then(function (stream) {
            setStream(stream);
            // create media recorder instance to initialize recording
            mediaRecorder.current = new MediaRecorder(stream);
            if (stream) {
                setIsPlaying(true);
                var containers = ['webm', 'ogg', 'mp4', 'x-matroska', '3gpp', '3gpp2', '3gp2', 'quicktime', 'mpeg', 'aac', 'flac', 'wav'];
                var supportedAudios = containers.map(function (format) { return "audio/".concat(format); }).filter(function (item) { return MediaRecorder.isTypeSupported(item); });
                // Detect Safari
                // const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (supportedAudios.length > 0) {
                    var media = new MediaRecorder(stream, {
                        mimeType: supportedAudios[0]
                    });
                    mediaRecorder.current = media;
                    //invokes the start method to start the recording process
                    mediaRecorder.current.start();
                    var localAudioChunks_1 = [];
                    mediaRecorder.current.ondataavailable = function (event) {
                        if (typeof event.data === "undefined")
                            return;
                        if (event.data.size === 0)
                            return;
                        localAudioChunks_1.push(event.data);
                    };
                    setAudioChunks(localAudioChunks_1);
                    dispatch(setDocDataUpdated(true));
                    dispatch(setIsTaskDetailsDataUpdated(true));
                    dispatch(setState({
                        key: "finalInspectorObservationDetails",
                        value: _objectSpread(_objectSpread({}, finalInspectorObservationDetails), {}, {
                            audioStart: true
                        })
                    }));
                    if (isDataUpdated) {
                        isDataUpdated(true);
                    }
                }
                else {
                    GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Audio not supported by browser");
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Audio not supported by browser",
                        type: "error"
                    }));
                }
            }
        }).catch(console.error);
    };
    var stopRecording = function () {
        setIsPlaying(false);
        setDisableSaveButton(false);
        //stops the recording instance
        if (mediaRecorder && mediaRecorder.current && mediaRecorder.current.state === 'recording') {
            setIsPlaying(false);
            mediaRecorder.current.stop();
            mediaRecorder.current.onstop = function () { return __awaiter(void 0, void 0, void 0, function () {
                var audioBlob, convertedBlob, audioUrl, blobUrl;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            audioBlob = new Blob(audioChunks, {
                                type: 'audio/mp4'
                            });
                            return [4 /*yield*/, convertBlobToWav(audioBlob)];
                        case 1:
                            convertedBlob = _a.sent();
                            audioUrl = URL.createObjectURL(audioBlob);
                            setAudioUrl(audioUrl);
                            blobUrl = URL.createObjectURL(convertedBlob);
                            // Fetch the Blob data
                            fetch(blobUrl).then(function (response) { return response.blob(); }).then(function (blob) {
                                // Create a new File object from the Blob
                                var mp3File = new File([blob], "audio-".concat(new Date().toISOString(), ".mp3"), {
                                    type: 'audio/mpeg'
                                });
                                // Use the File object as needed
                                setComplaint(_objectSpread(_objectSpread({}, complaint), {}, {
                                    audio: {
                                        audioBlobUrl: blobUrl,
                                        audioFile: mp3File,
                                        AttachmentId: ''
                                    },
                                    audioDuration: audioDuration
                                }));
                                dispatch(setState({
                                    key: "finalInspectorObservationDetails",
                                    value: _objectSpread(_objectSpread({}, finalInspectorObservationDetails), {}, {
                                        audioDuration: audioDuration,
                                        audio: {
                                            audioBlobUrl: blobUrl,
                                            audioFile: mp3File
                                        },
                                        audioStart: false
                                    })
                                }));
                            }).catch(function (error) { return console.error('Error fetching Blob:', error); });
                            setAudioChunks([]);
                            return [2 /*return*/];
                    }
                });
            }); };
        }
        ;
    };
    function formatTime(seconds) {
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        return "".concat(String(minutes).padStart(2, '0'), ":").concat(String(remainingSeconds).padStart(2, '0'));
    }
    var handleConfirmClick = function (data) {
        setComplaint(_objectSpread(_objectSpread({}, complaint), {}, {
            images: data
        }));
        setcomplaintsPhotographList(data);
        dispatch(setState({
            key: "finalInspectorObservationDetails",
            value: _objectSpread(_objectSpread({}, finalInspectorObservationDetails), {}, {
                images: data
            })
        }));
        dispatch(setDocDataUpdated(true));
        dispatch(setIsTaskDetailsDataUpdated(true));
        if (isDataUpdated) {
            isDataUpdated(true);
        }
        setDisableSaveButton(false);
    };
    var handleTextField = function (event) {
        var complaintDescription = event.target.value;
        dispatch(setState({
            key: "finalInspectorObservationDetails",
            value: _objectSpread(_objectSpread({}, finalInspectorObservationDetails), {}, {
                discription: complaintDescription
            })
        }));
        setComplaint(_objectSpread(_objectSpread({}, complaint), {}, {
            discription: complaintDescription
        }));
        dispatch(setDocDataUpdated(true));
        dispatch(setIsTaskDetailsDataUpdated(true));
        if (isDataUpdated) {
            isDataUpdated(true);
        }
        setDisableSaveButton(false);
    };
    var handleClickSave = function () {
        if (clearDataOnSave) {
            stopRecording();
            onDataReceived(complaint);
            setcomplaintsPhotographList([]);
            setComplaint({
                discription: '',
                images: [],
                audio: {
                    audioBlobUrl: '',
                    audioFile: '',
                    AttachmentId: ''
                },
                audioDuration: 0
            });
            setAudioUrl(null);
            setClearPopUpImages(true);
        }
        else {
            onDataReceived(complaint);
        }
        setDisableSaveButton(true);
        // setEnablePopUp(true)
    };
    var onClickRemovePhotoIcon = function (photoIndex, AttachmentId) { return __awaiter(void 0, void 0, void 0, function () {
        var _DeleteAttchementResp, _DeleteAttchementResp2, request, deletUrl, DeleteAttchementResponse, updatedComplaintList, updatedComplaintList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSingleImageSelected(false);
                    if (!AttachmentId) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {};
                    deletUrl = "";
                    request = {
                        SystemName: ESystemName.AssigntoFinalInspector,
                        ParentId: jobCardId,
                        AttachmentId: AttachmentId
                    };
                    deletUrl = deleteAllJobCardAttachmentsUrl;
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deletUrl,
                            request: request
                        }))];
                case 2:
                    DeleteAttchementResponse = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp === void 0 || (_DeleteAttchementResp = _DeleteAttchementResp.value) === null || _DeleteAttchementResp === void 0 ? void 0 : _DeleteAttchementResp.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp2 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp2 !== void 0 && (_DeleteAttchementResp2 = _DeleteAttchementResp2.value) !== null && _DeleteAttchementResp2 !== void 0 && _DeleteAttchementResp2.success) {
                        updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
                        updatedComplaintList.splice(photoIndex, 1);
                        setcomplaintsPhotographList(updatedComplaintList);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                    }
                    return [3 /*break*/, 5];
                case 4:
                    updatedComplaintList = __spreadArray([], complaintsPhotographList, true);
                    updatedComplaintList.splice(photoIndex, 1);
                    setcomplaintsPhotographList(updatedComplaintList);
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleEmptyImage = function (item) {
        setDisableSaveButton(false);
        setcomplaintsPhotographList([]);
    };
    var onDeleteRecording = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _DeleteAttchementResp3, _DeleteAttchementResp4, request, deletUrl, DeleteAttchementResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(savedAudio !== null && savedAudio !== void 0 && savedAudio.AttachmentId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {
                        SystemName: ESystemName.AssigntoFinalInspector,
                        ParentId: jobCardId,
                        AttachmentId: savedAudio === null || savedAudio === void 0 ? void 0 : savedAudio.AttachmentId
                    };
                    deletUrl = deleteAllJobCardAttachmentsUrl;
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deletUrl,
                            request: request
                        }))];
                case 2:
                    DeleteAttchementResponse = _a.sent();
                    if ((DeleteAttchementResponse === null || DeleteAttchementResponse === void 0 || (_DeleteAttchementResp3 = DeleteAttchementResponse.payload) === null || _DeleteAttchementResp3 === void 0 || (_DeleteAttchementResp3 = _DeleteAttchementResp3.value) === null || _DeleteAttchementResp3 === void 0 ? void 0 : _DeleteAttchementResp3.statusCode) == 200 || DeleteAttchementResponse !== null && DeleteAttchementResponse !== void 0 && (_DeleteAttchementResp4 = DeleteAttchementResponse.payload) !== null && _DeleteAttchementResp4 !== void 0 && (_DeleteAttchementResp4 = _DeleteAttchementResp4.value) !== null && _DeleteAttchementResp4 !== void 0 && _DeleteAttchementResp4.success) {
                        setAudioUrl(null);
                        setComplaint(_objectSpread(_objectSpread({}, complaint), {}, {
                            audio: {
                                audioBlobUrl: '',
                                audioFile: '',
                                AttachmentId: ''
                            },
                            audioDuration: 0
                        }));
                        setAudioDuration(0);
                        dispatch(setIsTaskDetailsDataUpdated(true));
                    }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setAudioUrl(null);
                    setComplaint(_objectSpread(_objectSpread({}, complaint), {}, {
                        audio: {
                            audioBlobUrl: '',
                            audioFile: '',
                            AttachmentId: ''
                        },
                        audioDuration: 0
                    }));
                    setAudioDuration(0);
                    dispatch(setIsTaskDetailsDataUpdated(true));
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    var handleClose = function () {
        setImageURL('');
        setISDrawerOpen(false);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: systemColor.white,
        borderRadius: 3
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: "12px 12px 0px 0px",
            padding: '2px'
        },
        width: "100%"
    }, /*#__PURE__*/ React.createElement(TextField, {
        disabled: isDisabled,
        id: "ComplaintDescription",
        placeholder: ComplaintInputPlaceHolder !== null && ComplaintInputPlaceHolder !== void 0 ? ComplaintInputPlaceHolder : 'Enter concerns',
        value: complaint.discription,
        multiline: true,
        rows: 4,
        variant: "outlined",
        fullWidth: true,
        onChange: handleTextField,
        sx: {
            "& fieldset": {
                border: 'none'
            }
        },
        inputProps: {
            maxLength: FreeTextMaxLength
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        direction: 'column',
        sx: {
            border: '1px solid #DEE4EB',
            borderRadius: "0px 0px 12px 12px",
            padding: '10px'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "center"
    }, complaintsPhotographList === null || complaintsPhotographList === void 0 ? void 0 : complaintsPhotographList.map(function (item, photoIndex) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        key: photoIndex,
        xs: 4,
        sm: 2,
        md: 1.5,
        lg: 4
    }, /*#__PURE__*/ React.createElement("div", {
        className: "1st",
        style: {
            position: 'relative',
            display: 'inline-block'
        }
    }, !isDisabled && /*#__PURE__*/ React.createElement(GridCloseIcon, {
        onClick: function () { return onClickRemovePhotoIcon(photoIndex, item.AttachmentId); },
        sx: {
            position: 'absolute',
            zIndex: 1,
            right: 4,
            top: 4,
            backgroundColor: "white",
            height: '15px',
            width: '15px',
            borderRadius: 50
        }
    }), /*#__PURE__*/ React.createElement("img", {
        src: item === null || item === void 0 ? void 0 : item.blobUrl,
        id: "downloadCustomerImg" + photoIndex,
        alt: "Image ".concat(photoIndex + 1),
        style: {
            width: '82px',
            height: '82px',
            borderRadius: '8px',
            position: 'relative'
        },
        onClick: function () { return handleClickImage(item === null || item === void 0 ? void 0 : item.blobUrl); }
    }))); })), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    })), audioUrl && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(AudioPlayer, {
        src: audioUrl,
        isSlider: true,
        audioDuration: audioDuration
    }), !isDisabled && /*#__PURE__*/ React.createElement("img", {
        src: DeleteButtonNewIcon,
        alt: "gallery-disable",
        style: {
            width: '36px',
            height: '36px',
            marginLeft: '10px'
        },
        onClick: onDeleteRecording
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        spacing: 0,
        padding: 0
    }, /*#__PURE__*/ React.createElement(IconButton, {
        id: "add-photo-icon",
        disabled: isDisabled,
        onClick: onOpenClick
    }, isDisabled ? /*#__PURE__*/ React.createElement(GalleryIcon, {
        sx: {
            color: systemColor.disabled
        }
    }) : /*#__PURE__*/ React.createElement(GalleryIcon, {
        sx: {
            color: systemColor.primary
        }
    })), isRecordAudio && /*#__PURE__*/ React.createElement(React.Fragment, null, !isPlaying ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconButton, {
        disabled: isDisabled || audioUrl !== "" && audioUrl !== null && audioUrl !== undefined,
        onClick: startRecording,
        style: {},
        id: "startRecording"
    }, isDisabled || audioUrl !== "" && audioUrl !== null && audioUrl !== undefined ? /*#__PURE__*/ React.createElement(AudioButtonIcon, {
        sx: {
            stroke: systemColor.disabled
        }
    }) : /*#__PURE__*/ React.createElement(AudioButtonIcon, {
        sx: {
            stroke: systemColor.primary
        }
    }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: stopRecording,
        style: {},
        id: "startRecording"
    }, /*#__PURE__*/ React.createElement(Img, {
        src: BluePauseIconNew,
        alt: "audioplayicon"
    })), /*#__PURE__*/ React.createElement(Img, {
        src: AudioFrameIcon,
        alt: "audioplayicon",
        style: {
            width: '78px',
            height: '20px'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        sx: {
            color: '#1B1D21',
            marginLeft: "5px"
        }
    }, formatTime(audioDuration))))), !isFromTaskDetails && ((createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isEstimate) == 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isInspection) == 'Update' || (createAndEditFlow === null || createAndEditFlow === void 0 ? void 0 : createAndEditFlow.isAppointment) == 'Update') || isFromFinalInspection ? /*#__PURE__*/ React.createElement(MuiButton, {
        id: "saveCustomerComplaint",
        name: t('Save'),
        size: "small",
        variant: "contained",
        onClick: handleClickSave,
        disabled: disableSaveButton || isPlaying || !(complaint !== null && complaint !== void 0 && complaint.discription) || isDisabled,
        style: {
            marginTop: "4px"
        }
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null))))), /*#__PURE__*/ React.createElement(ImageCaptureAndFileupload, {
        open: open,
        clearPopUpImages: clearPopUpImages,
        isImageEmpty: function (value) { return handleEmptyImage(value); },
        handleModelClose: function (value) { return handleCancleClick(value); },
        handleConfirm: function (data) { return handleConfirmClick(data); },
        downloadedImages: complaintsPhotographList,
        systemName: ESystemName.AssigntoFinalInspector,
        ParentId: jobCardId || "",
        deleteUrl: deleteAllJobCardAttachmentsUrl
    }));
};
